<div role="presentation" class="ag-tabs-body ag-menu-body">
  <div class="ag-filter">
    <div class="ag-filter-body-wrapper ag-set-filter-body-wrapper">
      <div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
        <div
          class="ag-filter-select ag-labeled ag-label-align-left ag-select selectWrapper"
          role="presentation"
        >
          <div
            class="ag-wrapper ag-picker-field-wrapper ag-picker-field-wrapper-custom"
            aria-expanded="false"
            role="listbox"
            aria-label="Filtering operator"
            tabindex="0"
          >
            <mat-select
              [formControl]="filterOperation"
              tabindex="-1"
              class="options matSelect"
              panelClass="text-filter-options-panel"
            >
              @for (filter of textFilterTypes; track filter) {
              <mat-option
                class="ag-custom-component-popup text-filter-option mat-option-selected"
                [value]="getTextFilterTypeKey(filter)"
                >{{ filter }}</mat-option
              >
              }
            </mat-select>
          </div>
        </div>
        <div class="ag-filter-body" role="presentation">
          <!--AG-INPUT-TEXT-FIELD-->
          <div
            role="presentation"
            class="ag-filter-from ag-filter-filter ag-labeled ag-label-align-left ag-text-field ag-input-field"
          >
            <div
              class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper inputTextField"
              role="textbox"
            >
              <input
                class="ag-input-field-input ag-text-field-input custom-filter"
                type="text"
                placeholder="Filter..."
                aria-label="Filter Value"
                [tabIndex]="0"
                [formControl]="textFilterValue"
                #textInput
                (keyup)="twoConditionActive($event)"
              />
            </div>
          </div>
        </div>
        @if (isTextFilterCondition) {
        <div class="joinCondition">
          <div class="ag-filter-condition radioBtnGroup">
            <!--AG-RADIO-BUTTON-->
            <mat-radio-group
              aria-label="Select an option"
              [formControl]="joinOperator"
            >
              <div
                role="presentation"
                class="ag-filter-condition-operator ag-filter-condition-operator-and ag-labeled ag-label-align-right ag-radio-button ag-input-field"
              >
                <div class="ag-wrapper ag-input-wrapper" role="presentation">
                  <mat-radio-button
                    name="operator"
                    tabindex="0"
                    class="ag-input-field-label ag-label ag-radio-button-label"
                    value="AND"
                    >AND
                  </mat-radio-button>
                  <mat-radio-button
                    name="operator"
                    tabindex="0"
                    class="ag-input-field-label ag-label ag-radio-button-label"
                    value="OR"
                    >OR
                  </mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
          <div
            class="ag-filter-select ag-labeled ag-label-align-left ag-select selectWrapper"
            role="presentation"
          >
            <div class="ag-label ag-hidden" role="presentation"></div>
            <div
              class="ag-wrapper ag-picker-field-wrapper ag-picker-field-wrapper-custom"
              aria-expanded="false"
              role="listbox"
              aria-label="Filtering operator"
              tabindex="0"
            >
              <mat-select
                [formControl]="filterOperation2"
                class="matSelect"
                panelClass="text-filter-options-panel"
              >
                @for (filter of textFilterTypes; track filter) {
                <mat-option
                  class="ag-custom-component-popup text-filter-option mat-option-selected"
                  [value]="getTextFilterTypeKey(filter)"
                  >{{ filter }}</mat-option
                >
                }
              </mat-select>
            </div>
          </div>
          <div class="ag-filter-body" role="presentation">
            <!--AG-INPUT-TEXT-FIELD-->
            <div
              role="presentation"
              class=".ag-filter-from ag-filter-filter ag-labeled ag-label-align-left ag-text-field ag-input-field"
            >
              <div
                class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper"
                role="presentation"
              >
                <input
                  class="ag-input-field-input custom-filter"
                  type="text"
                  step="any"
                  placeholder="Filter..."
                  aria-label="Filter from value"
                  [formControl]="textFilterValue2"
                />
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <div
        role="presentation"
        class="ag-mini-filter ag-labeled ag-label-align-left ag-text-field ag-input-field eMiniFilter"
      >
        <div
          class="ag-input-field-label ag-label ag-hidden ag-text-field-label"
          role="presentation"
        ></div>
        <div
          class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper"
          role="presentation"
        >
          <input
            class="ag-input-field-input ag-text-field-input miniFilter custom-filter"
            type="text"
            aria-label="Search filter values"
            placeholder="Search..."
            tabindex="0"
            [formControl]="miniSearchFilter"
          />
        </div>
      </div>
      <div class="ag-set-filter-list setFilterCustom" role="presentation">
        <div
          class="ag-virtual-list-viewport ag-filter-virtual-list-viewport"
          role="presentation"
        >
          <div
            class="ag-virtual-list-container ag-filter-virtual-list-container"
            role="listbox"
            aria-label="Filter List"
            (keydown.tab)="$event.stopPropagation()"
            (keydown.shift.tab)="$event.stopPropagation()"
          >
            <div
              class="ag-virtual-list-item ag-filter-virtual-list-item"
              role="option"
              aria-setsize="2"
              style="position: relative"
              aria-posinset="1"
              tabindex="0"
              aria-checked="false"
            >
              <!--AG-CHECKBOX-->
              <div class="ag-set-filter-item" tabindex="-1">
                <div
                  role="presentation"
                  class="ag-set-filter-item-checkbox ag-labeled ag-label-align-right ag-checkbox ag-input-field"
                >
                  @if (subClientReferences.length > 0) {
                  <mat-checkbox
                    class="selectAll mat-checkbox-input setFilterCheckbox"
                    color="primary"
                    [tabIndex]="-1"
                    [checked]="allChecked"
                    [(ngModel)]="allSelected"
                    [formControl]="allSelectedControl"
                    [indeterminate]="isIndeterminate()"
                  >
                    (Select All)
                  </mat-checkbox>
                  } @else { No matches }
                </div>
              </div>
            </div>
            @for (subClientReference of subClientReferences; track
            subClientReference) {
            <div
              class="ag-virtual-list-item ag-filter-virtual-list-item"
              role="option"
              aria-setsize="2"
              style="position: relative"
              aria-posinset="1"
              tabindex="0"
              aria-checked="false"
            >
              <!--AG-CHECKBOX-->
              <div class="ag-set-filter-item matCheckbox">
                <div
                  role="presentation"
                  class="ag-set-filter-item-checkbox ag-labeled ag-label-align-right ag-checkbox ag-input-field"
                >
                  <mat-checkbox
                    class="clientReferences setFilterCheckbox"
                    color="primary"
                    [tabIndex]="-1"
                    [checked]="subClientReference.checked"
                    (change)="
                      onCheckboxChange({
                        checked: $event.checked,
                        source: { value: subClientReference }
                      })
                    "
                    #checkboxReference
                  ></mat-checkbox>
                  <div
                    class="ag-reference-label ag-label ag-input-field-label ag-checkbox-label ag-custom-label"
                    (click)="
                      onCheckboxChangeWithLabel(
                        checkboxReference,
                        subClientReference
                      )
                    "
                  >
                    {{ subClientReference.subClientReferenceText }}
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="ag-filter-apply-panel">
      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="applyFilter()"
      >
        Apply
      </button>
      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="clearFilter()"
      >
        Clear
      </button>
    </div>
  </div>
</div>
